import React from "react";
import blogsData from "../../data/blogsData";
import { Link } from "react-router-dom";
import "./AllBlogs.scss";

export default function AllBlogs() {
  const sortedBlogs = [...blogsData].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <section className="all-blogs-page">
      <div className="container">
        
        <div className="text-content">
          <h2>Our Blog Articles</h2>
          <p>Explore expert guides, tips, and insights on dental care.</p>
        </div>

        <div className="blog-grid">
          {sortedBlogs.map((blog) => (
            <Link 
              to={`/blog/${blog.slug}`} 
              key={blog.id} 
              className="blog-card full-card-click"
            >
              <div className="blog-img">
                <img src={blog.image} alt={blog.title} />
              </div>

              <div className="blog-content">
                <h3>{blog.title}</h3>

                <div className="blog-meta">
                  <span className="date">
                    {new Date(blog.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </span>
                  <span className="readtime">{blog.readTime}</span>
                </div>

                <p>{blog.shortDescription}</p>

                <span className="read-more">Read More →</span>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
